var _path, _mask, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBatteryFull(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 12,
    viewBox: "0 0 23 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.855469 1C0.855469 0.447715 1.30318 0 1.85547 0H15.9414C16.4937 0 16.9414 0.447715 16.9414 1V12H0.855469V1Z",
    fill: "#171717"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_2773_1271",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.855469 1C0.855469 0.447715 1.30318 0 1.85547 0H18.3941C18.9464 0 19.3941 0.447715 19.3941 1V11C19.3941 11.5523 18.9464 12 18.3941 12H1.85547C1.30318 12 0.855469 11.5523 0.855469 11V1Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.85547 1H18.3941V-1H1.85547V1ZM18.3941 1V11H20.3941V1H18.3941ZM18.3941 11H1.85547V13H18.3941V11ZM1.85547 11V1H-0.144531V11H1.85547ZM1.85547 11H1.85547H-0.144531C-0.144531 12.1046 0.750898 13 1.85547 13V11ZM18.3941 11V13C19.4987 13 20.3941 12.1046 20.3941 11H18.3941ZM18.3941 1H20.3941C20.3941 -0.104569 19.4987 -1 18.3941 -1V1ZM1.85547 -1C0.7509 -1 -0.144531 -0.10457 -0.144531 1H1.85547V1V-1Z",
    fill: "#171717",
    mask: "url(#path-2-inside-1_2773_1271)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3848 4.19482C18.3848 3.64254 18.8325 3.19482 19.3848 3.19482H21.0359C21.5882 3.19482 22.0359 3.64254 22.0359 4.19482V7.80568C22.0359 8.35796 21.5882 8.80568 21.0359 8.80568H19.3848C18.8325 8.80568 18.3848 8.35796 18.3848 7.80568V4.19482Z",
    fill: "#171717"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryFull);
export default __webpack_public_path__ + "static/media/battery_full.2c2f45adfe698ec825f35f983f1e03df.svg";
export { ForwardRef as ReactComponent };